<template>
  <div class="w-fullVw h-fullVh">
    <iframe
      id="faceFrame"
      ref="faceFrame"
      class="faceFrame"
      width="100%"
      height="100%"
      :src="url"
    />
  </div>
</template>

<script>
import mixin from '@/mixin'
import {} from '@/components'
// import API from '@/api'
export default {
  mixins: [mixin],
  components: {},
  props: {},
  data() {
    return {
      url: this.$route.query.url || ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    // this.$refs.faceFrame.allow = 'Camera;Fullscreen;microphone;autoplay'
    const _faceFrame = document.getElementById('faceFrame')
    _faceFrame.setAttribute('allow', 'Camera;Fullscreen;microphone;autoplay')
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.faceFrame {
  border: medium none;
}
</style>
